
import { AxiosRequestConfig } from 'axios'
import { Repository } from 'ecp/repositories/Repository'
import { IBalances } from 'egi/app/Import/importInterfaces'
import { IExistingRefinancingInfo } from 'egi/app/ProductChooser/ProductChooser'
import { IFinishedProposalsToRefinance, IRefinancingClient } from 'egi/app/Refinancing/refinancingInterfaces'
import { ISimulation } from 'egi/types'
import api from 'services/api'

class RefinancingRepository extends Repository {
  /* GET /refinancing/:cpfCnpj/client */
  async getClientData (cpfCnpj: string, config?: AxiosRequestConfig) {
    return Repository.handle<{ client: IRefinancingClient }>(() =>
      this.api.get(`${this.path}/${cpfCnpj}/client`, config)
    )
  }

  /* GET /refinancing/:cpfCnpj/actives */
  async getActiveRefinancings (cpfCnpj: string, config?: AxiosRequestConfig) {
    return Repository.handle<IExistingRefinancingInfo>(() =>
      this.api.get(`${this.path}/${cpfCnpj}/actives`, config)
    )
  }

  /* GET /refinancing/:cpfCnpj/finished-proposals */
  async getFinishedProposalsToRefinance (cpfCnpj: string, config?: AxiosRequestConfig) {
    return Repository.handle<{ proposals: IFinishedProposalsToRefinance[] }>(() =>
      this.api.get(`${this.path}/${cpfCnpj}/finished-proposals`, config)
    )
  }

  /* GET /refinancing/:cpfCnpj/outstanding-balance/:contractNumber */
  async getOutstandingBalance (cpfCnpj: string, contractNumber: string, config?: AxiosRequestConfig) {
    return Repository.handle<{ outstandingBalance: IBalances }>(() =>
      this.api.get(`${this.path}/${cpfCnpj}/outstanding-balance/${contractNumber}`, config)
    )
  }

  /* POST /refinancing/simulation */
  async createSimulationFromFinishedProposal (proposalId: string, config?: AxiosRequestConfig) {
    return Repository.handle<{ simulation: ISimulation }>(() =>
      this.api.post(`${this.path}/simulation`, { proposalId }, config)
    )
  }
}
export default new RefinancingRepository({ api, path: '/refinancing' })
